import { useSnackbar } from 'notistack'
import React from 'react'
import { getCookie } from '../../Utils/CookieHelper';
import { useEffect } from 'react';
import Service from '../../Networking/NetworkingUtils';
import VersionTable from './VersionTable';
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';

var token = getCookie("bb_metaverse_token");
// var access = JSON.parse(getCookie("bb_metaverse_access"));
var user = JSON.parse(getCookie("bb_metaverse_user"))


const AssetTable = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(true)
    const [assetDialog, setAssetDialog] = React.useState(false)
    const [versionDialog, setversionDialog] = React.useState(false)
    const [tableData, setTableData] = React.useState([])
    const [assets, setAssets] = React.useState([])
    const [name, setName] = React.useState('')
    const [description, setDescription] = React.useState('')
    const [assetType, setAssetType] = React.useState(null)
    const [fileName, setFileName] = React.useState('')
    const [packageName, setPackageName] = React.useState('')
    const [methodType, setMethodType] = React.useState('Add')
    const [buttonDisabled, setButtonDisabled] = React.useState(false)
    const [selectedRow, setSelectedRow] = React.useState(null)
    const [active, setActive] = React.useState(null)
    const [projectDirectoryData, setProjectDirectoryData] = React.useState([])
    const [selectedProjectDirectory, setSelectedProjectDirectory] = React.useState(null)
    const [accessListObj, setAccessListObj] = React.useState({})
    const [accessList, setAccessList] = React.useState([])
    const [search, setSearch] = React.useState('')
    const [columns] = React.useState([
        { title: 'Name', field: 'name', },
        { title: 'Description', field: 'description', },
        { title: 'Asset Type', field: 'asset_name' },
        { title: 'Active', field: 'is_active', lookup: { true: 'Enabled', false: 'Disabled' } }
    ])


    useEffect(() => {
        getData()
        getAssets()
        getProjectDirectory()
        getAccessList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAccessList() {
        setLoading(true)
        Service.get(`/api/projects/access/list/get_project_access_list/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setAccessList(res.data)
                var obj = {}
                for (let i = 0; i < res.data.length; i++) {
                    const element = res.data[i];
                    obj[element.id] = element.name
                }
                setAccessListObj(obj)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }


    function getProjectDirectory() {
        Service.get(`/api/program/version/get_project_program_directory_and_versions/?project_id=${props.data.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setProjectDirectoryData(res.data)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function getData() {
        Service.get(`/api/projects/asset/get_project_assets/?project=${props.data.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setTableData(res.data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function getAssets() {
        Service.get(`/api/asset/types/get_asset_types/`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setAssets(res.data)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function handleClose() {
        setButtonDisabled(false)
        setAssetDialog(false)
        setName('')
        setDescription("")
        setAssetType(null)
        setFileName('')
        setPackageName('')
        setActive(null)
        setSelectedRow(null)
    }

    function handleVersionDialogClose() {
        setversionDialog(false)
        setSelectedRow(null)
    }

    function addAsset() {
        var fields = ''
        if (!name) {
            fields = "Name"
        }
        if (!assetType) {
            fields += !fields ? "Asset Type" : ", Asset Type"
        }
        if (!selectedProjectDirectory && assetType && assetType.asset_key === 'cloud_gl') {
            fields += !fields ? "Project Directory" : ", Project Directory"
        }
        if (fields) {
            enqueueSnackbar(fields + ' is Empty!', {
                variant: 'warning'
            })
        } else {
            setButtonDisabled(true)
            let postData = {
                name: name,
                description: description,
                project: props.data.id,
                created_by: user.id,
                asset_type: assetType.id,
                is_active: active,
            }
            if (assetType && assetType.asset_key === 'cloud_gl') {
                postData['program_directory'] = selectedProjectDirectory ? selectedProjectDirectory.id : null
            }
            Service.post(`/api/projects/asset/create_project_asset/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: postData
            })
                .then(res => {
                    enqueueSnackbar('Asset Added Successfully', {
                        variant: 'success'
                    });
                    setButtonDisabled(false)
                    setAssetDialog(false)
                    setName('')
                    setDescription("")
                    setAssetType(null)
                    setFileName('')
                    setPackageName('')
                    getData()
                })
                .catch(error => {
                    console.log(error)
                    setButtonDisabled(false)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    function editAsset() {
        var fields = ''
        if (!name) {
            fields = "Name"
        }
        if (!assetType) {
            fields += !fields ? "Asset Type" : ", Asset Type"
        }
        if (!selectedProjectDirectory && assetType && assetType.asset_key === 'cloud_gl') {
            fields += !fields ? "Project Directory" : ", Project Directory"
        }
        if (fields) {
            enqueueSnackbar(fields + ' is Empty!', {
                variant: 'warning'
            })
        } else {
            setButtonDisabled(true)
            let putData = {
                name: name,
                description: description,
                project: props.data.id,
                created_by: user.id,
                asset_type: assetType.id,
                program_directory: selectedProjectDirectory ? selectedProjectDirectory.id : null,
                is_active: active,
                id: selectedRow.id,


            }
            Service.patch('/api/projects/asset/edit_project_asset/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: putData
            })
                .then(res => {
                    enqueueSnackbar('Asset edited Successfully', {
                        variant: 'success'
                    });
                    setButtonDisabled(false)
                    setAssetDialog(false)
                    setName('')
                    setDescription("")
                    setAssetType(null)
                    setFileName('')
                    setPackageName('')
                    setSelectedRow(null)
                    getData()
                })
                .catch(error => {
                    console.log(error)
                    setButtonDisabled(false)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }


    const handleActive = (event) => {
        setActive(event.target.value)
    }

    const selectedEditAsset = (e, row) => {
        e.stopPropagation()
        setMethodType("Edit")
        setSelectedRow(row)
        setName(row.name)
        setDescription(row.description)
        for (let i = 0; i < assets.length; i++) {
            const element = assets[i];
            if (element.id === row.asset_type) {
                setAssetType(element)
                break
            }
        }
        setActive(row.is_active)
        for (let j = 0; j < projectDirectoryData.length; j++) {
            const dir = projectDirectoryData[j];
            if (dir.id === row.program_directory) {
                setSelectedProjectDirectory(dir)
                break
            }
        }
        setAssetDialog(true)
    }

    const filteredTableData = tableData.filter(row =>
        columns.some(column => String(column.lookup ? column.lookup[row[column.field]] : row[column.field] || '').toLowerCase().includes(search.toLowerCase()))
    )

    return (
        <div>
            {/* <MaterialTable
                title={props.data?.name}
                isLoading={loading}
                data={tableData}
                columns={[
                    { title: 'Name', field: 'name', },
                    { title: 'Description', field: 'description', },
                    { title: 'Asset Type', field: 'asset_name' },
                    {
                        title: 'File Name', field: 'asset_parameter', editable: 'never',
                        render: rowData => rowData.asset_parameter?.open_file
                    },
                    {
                        title: 'Package Name', field: 'asset_parameter', editable: 'never',
                        render: rowData => rowData.asset_parameter?.package_name
                    },
                    {
                        title:'Active',field: 'is_active',lookup:{ true: 'Enabled', false: 'Disabled' } 
                    }
                ]}
                options={{
                    paging: false,
                    headerStyle: {
                        fontWeight: 'bold',
                    },
                    actionsColumnIndex: -1,
                    filtering: true,
                    detailPanelColumnStyle: { display: 'none' }
                }}
                actions={[
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add',
                        isFreeAction: true,
                        onClick: () => { setMethodType("Add"); setAssetDialog(true) }
                    },
                    // rowData => ({
                    //     icon: 'add',
                    //     tooltip: 'Add Versions',
                    //     disabled: rowData.configure_parameter ? rowData.asset_parameter === null : false,
                    //     onClick: () => { setSelectedRow(rowData); setversionDialog(true) }
                    // }),
                    {
                        icon: 'edit',
                        tooltip: 'Edit',
                        onClick: (e, rowData) => openEdit(rowData)
                    },
                ]}
                onRowClick={(event, rowData, toggleDetailPanel) => {
                    // toggleDetailPanel()
                setSelectedRow(rowData); setversionDialog(true)
                }}
                sx={{ width: '100%' }}
            /> */}
            {loading ? <Box display='flex' justifyContent={'center'} alignItems='center' width='100%'><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                        <Typography variant="h5">{props.data?.name}</Typography>
                        <Box display='flex' alignItems='center' gap={1}>
                            <TextField
                                size='small'
                                variant='outlined'
                                placeholder='Search'
                                value={search}
                                onChange={(event) => setSearch(event.target.value)}
                                InputProps={{ endAdornment: <SearchIcon /> }}
                            />
                            <Button onClick={() => { setAssetDialog(true); setMethodType("Add") }}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredTableData && filteredTableData.map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow onClick={() => {
                                            setversionDialog(true);
                                            setSelectedRow(row);
                                        }} >
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                </TableCell>
                                            ))}
                                            <TableCell display='flex' justifyContent='space-evenly' alignItems='center'>
                                                <Tooltip title="Edit"><span><IconButton onClick={(e) => { selectedEditAsset(e, row) }}><EditIcon /></IconButton></span></Tooltip>
                                                {/* <Tooltip title="Upload"><span><IconButton disabled={row.object_source} onClick={() => { setSelectedRow(row); console.log(row); setOpenUpload(true) }}><FileUploadIcon /></IconButton></span></Tooltip> */}
                                                {/* <Tooltip title="Upload Thumbnail"><IconButton onClick={() => { setThumbnailUploadDialog(true); setSelectedRow(row) }}><CloudUploadIcon /></IconButton></Tooltip> */}
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </React.Fragment>
                </TableContainer>
            }

            <Dialog maxWidth="xs" fullWidth={true} open={assetDialog} onClose={handleClose} >
                <DialogTitle marginTop="2px" spacing={2}>{methodType + " "}Asset</DialogTitle>
                <DialogContent>
                    <Box display='flex' flexDirection={'column'} justifyContent={'center'}>
                        <Box mt={1}>
                            <TextField fullWidth autoComplete="off" value={name} variant="outlined" label="Name" onChange={(e) => { setName(e.target.value) }}></TextField>
                        </Box>
                        <Box mt={1}>
                            <TextField fullWidth autoComplete="off" value={description} variant="outlined" label="Description" onChange={(e) => setDescription(e.target.value)}></TextField>
                        </Box>
                        <Box mt={1}>
                            <Autocomplete
                                fullWidth
                                id="asset"
                                selectOnFocus={true}
                                options={assets}
                                value={assetType}
                                getOptionLabel={(option) => option['name'] ? option['name'] : ''}
                                isOptionEqualToValue={(option, value) => value && option.id === value.id}
                                renderInput={(params) => <TextField variant='outlined'  {...params} label="Asset type" />}
                                onChange={(event, values) => {
                                    if (values !== null) {
                                        setAssetType(values)
                                        setFileName('')
                                        setPackageName('')
                                    } else {
                                        setAssetType(null)
                                        setFileName('')
                                        setPackageName('')
                                    }
                                }}
                            />
                        </Box>
                        {
                            assetType && assetType.key === 'cloud_gl' ?
                                <Box mt={1}>
                                    <Autocomplete
                                        fullWidth
                                        id="asset"
                                        selectOnFocus={true}
                                        options={projectDirectoryData}
                                        value={selectedProjectDirectory}
                                        getOptionLabel={(option) => option['name'] ? option['name'] : ''}
                                        isOptionEqualToValue={(option, value) => value && option.id === value.id}
                                        renderInput={(params) => <TextField variant='outlined'  {...params} label="Project Directory" />}
                                        onChange={(event, values) => {
                                            setSelectedProjectDirectory(values)
                                        }}
                                    />
                                </Box> : null

                        }
                        {
                            assetType && assetType.configure_parameter && assetType.os_platform === "windows" ?
                                <Box display='flex' flexDirection={'column'} justifyContent={'center'}>
                                    <Box mt={1}>
                                        <TextField fullWidth autoComplete="off" value={fileName} variant="outlined" label="File Name" onChange={(e) => { setFileName(e.target.value) }}></TextField>
                                    </Box>
                                </Box>
                                : null
                        }
                        {
                            assetType && assetType.configure_parameter && assetType.os_platform === "android" ?
                                <Box display='flex' flexDirection={'column'} justifyContent={'center'}>
                                    <Box mt={1}>
                                        <TextField fullWidth autoComplete="off" value={packageName} variant="outlined" label="Package Name" onChange={(e) => { setPackageName(e.target.value) }}></TextField>
                                    </Box>
                                </Box>
                                : null
                        }
                        <Box mt={1}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="version_head">Active</InputLabel>
                                <Select
                                    variant="outlined"
                                    labelId="demo-simple-select-label"
                                    id="version_head"
                                    defaultValue={active}
                                    label="Active"
                                    onChange={handleActive}
                                >
                                    <MenuItem value={true}>Enabled</MenuItem>
                                    <MenuItem value={false}>Disabled</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={handleClose}>Cancel</Button>
                    {methodType === "Add" ?
                        <Button disabled={buttonDisabled} color="primary" variant="text" onClick={() => addAsset()}>Add</Button> :
                        <Button disabled={buttonDisabled} color="primary" variant="text" onClick={() => editAsset()}>Edit</Button>}
                </DialogActions>

            </Dialog>

            <Dialog maxWidth="lg" fullWidth={true} open={versionDialog} onClose={handleVersionDialogClose} >
                <DialogTitle marginTop="2px" spacing={2}>{selectedRow?.name}</DialogTitle>
                <DialogContent>
                    <VersionTable data={selectedRow} project={props.data} accessListObj={accessListObj} accessList={accessList} />
                </DialogContent>
            </Dialog>
        </div>
    )
}

// export default withSnackbar(AssetTable)
export default AssetTable;


